// Mirror of the engine's level palette (see @novorender/api octree node.ts nodeLevelColor)
// so the tree swatches line up with the rendered frame colors.
export function octreeLevelColor(level: number): string {
    const hue = (level * 0.61803398875) % 1; // golden ratio conjugate
    return `hsl(${Math.round(hue * 360)}, 70%, 55%)`;
}

export const octreeSelectedColor = "#ffffff";
